import * as React from 'react';

export const FiltersSvg: React.FC = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={20} height={21} fill='none'>
      <path
        stroke='#60708E'
        strokeLinecap='round'
        strokeWidth={1.2}
        d='M3.75 17.75v-9m10.5-4.5v3-3Zm0 13.5v-7.5 7.5ZM9 4.25v9-9Zm0 13.5v-1.5 1.5ZM3.75 4.25v1.5-1.5ZM12.75 8.75a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0ZM7.5 14.75a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0ZM2.25 7.25a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Z'
      />
    </svg>
  );
};
